import React from 'react';
import { 
    Form, 
    Input, 
    Button, 
    Flex, 
    Radio, 
    Divider, 
    Switch, 
    Space, 
    Alert,
    Select,
    message,
    Modal,
    List,
    Popconfirm,
    InputNumber,
    DatePicker,
    TimePicker,
    Checkbox,
    Card
} from 'antd';
import dayjs from 'dayjs';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import goback from '../../utils/goback';
import SwitchShop from '../shop/switch-shop';
import SelectGoods from '../goods/select-goods';
import Geo from '../../components/geo';
import getCurrentShop from '../shop/get-current-shop';
import { getCurrentShopId } from '../shop/get-current-shop';

dayjs.locale('zh-cn');

const { confirm } = Modal;

const NewOrder = (props) => {
    const defFromOptions = [
        {label: '线下', value: '线下'},
        {label: '公司电话', value: '公司电话'},
        {label: '抖音团购', value: '抖音' }, 
        {label: '美团团购', value: '美团'},
        {label: '小红书', value: '小红书'},
    ];

    const [currentShopId, setCurrentShopId] = React.useState(null);
    const [currentShop, setCurrentShop] = React.useState(null);
    const [unit, setUnit] = React.useState();
    const [goodsType, setGoodsType] = React.useState();
    const [form] = Form.useForm();
    const shareType = Form.useWatch('shareType', form);
    const [fromOptions, setFromOptions] = React.useState(defFromOptions);
    const amount = Form.useWatch('shouldAmount', form);
    const quantity = Form.useWatch('quantity', form);
    const [proxyShops, setProxyShops] = React.useState([]);
    const [multiSku, setMultiSku] = React.useState(false);
    const [skuTitle, setSkuTitle] = React.useState('');
    const [skus, setSkus] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {

    }, []);

    React.useEffect(() => {
        const fetchCurrentShopId = async () => {
            const id = await getCurrentShopId();
            setFormFields({sendSms: true});
            getProxyShops().then(res => {
                // console.log('proxyShops', res);
                setProxyShops(res.map(item => {
                    return {
                        // ...item,
                        label: item?.partnerShop?.title,
                        value: item?.partnerShop?.shopId
                    }
                }));
            });
        };

        fetchCurrentShopId();
    }, []);

    const setFormFields = (data) => {
        console.log('setFormFields', data);

        form.setFieldsValue({
            ...data,
            shouldAmount: data.shouldAmount || 0,
            quantity: data.quantity || 1,
        });

        if(data.appointmentTime) {
            form.setFieldsValue({
                appointmentDate: dayjs(data.appointmentTime),
                appointmentTime: dayjs(data.appointmentTime),
            });
        }
    }

    const onGoodsChange = async (goods) => {
        console.log('onGoodsChange', goods);
        goods = goods[0];

        setUnit(goods?.unit);
        setGoodsType(goods?.type);

        if(goods?.multiSku) {
            setMultiSku(goods.multiSku);
            setSkuTitle(goods.skuTitle);
            setSkus({name: goods.skuTitle, options: goods.goods_skus});
        }else{
            setMultiSku(false);
            setSkus(null);
            setSkuTitle(null);
        }
    }

    const getOrderDetail = async (orderNo) => {
        const response = await fetch(`/api/order-detail-als?orderNo=${orderNo}`);
        const result = await response.json();
        if(result.success) {
            return result.data;
        }
    }

    const getProxyShops =  async () => { 
        if (!currentShopId) return [];
        const response = await fetch(`/api/shop/partner/list?shopId=${currentShopId}`);
        const result = await response.json();

        if(result.success) {
            return (result?.data?.rows || []);
        }

        return [];
    }


    const onFormSubmit = async () => {
        form.validateFields().then(async values => {
            console.log('values', values);
            const goodsId = values.goodsId?.[0]?.goodsId;
            // 预约时间
            let appointmentTime = values.appointmentDate ? dayjs(values.appointmentDate).format('YYYY-MM-DD') : '';

            if(values.appointmentTime) {
                appointmentTime += ' ' + dayjs(values.appointmentTime).format('HH:mm');
            }

            const currentShopId = await getCurrentShopId();
            const data = {
                ...values,
                goodsId,
                appointmentTime,
                province: values.geo?.[0]?.name,
                provinceCode: values.geo?.[0]?.adcode,
                city: values.geo?.[1]?.name,
                cityCode: values.geo?.[1]?.adcode,
                county: values.geo?.[2]?.name,
                countyCode: values.geo?.[2]?.adcode,
                shopId: currentShopId,
                goodsType,
                unit,
            }

            if(multiSku) {
                data.multiSku = multiSku;
                data.skuList = skus?.options;
            }

            delete data.geo;
            delete data.appointmentDate;

            console.log('data', data);
            requestOrderCreate(data);
        }).catch(err => {
            console.log('err', err);
        })
    }

    const requestOrderCreate = async (data) => {
        const url = '/api/order/create';
        setLoading(true);
        message.loading('正在创建订单...');
        
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        if(result.success) {
            message.success('创建成功');
            setTimeout(() => {
                window.location.href = '/order';
            }, 500);
        } else {
            message.error(result.data);
        }
        setLoading(false);
    }

    return (
        <>
            <SwitchShop />
                
            <h2 className="admin-page-title">创建订单</h2>
                
            <Alert 
                message={`本次订单将在“${currentShop?.title || '当前'}”店铺下创建，右上角可切换店铺`} 
                type="warning" 
                showIcon 
                className="mb-4"
            />
                
            <div className="admin-form-container">
                <Form form={form} layout="vertical" disabled={loading}>
                    <Form.Item
                        label="服务项目"
                        name="goodsId"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <SelectGoods onChange={onGoodsChange} includeProxy={true} />
                    </Form.Item>
                    {
                        multiSku && <Form.Item
                            label={skuTitle}
                            name="skuId"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Radio.Group options={skus.options.map(i => ({ ...i, key: i.skuId, label: i.title, value: i.skuId }))} />
                        </Form.Item>
                    }
                    {/* 手机号码和客户名称 - 响应式布局 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                        <Form.Item
                            label="手机号码"
                            name="phoneNo"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入手机号码',
                                },
                                {
                                    pattern: /^1[3456789]\d{9}$/,
                                    message: '请输入正确的手机号码',
                                }
                            ]}
                        >
                            <Input className="admin-form-input" type='number' placeholder="请输入手机号码" />
                        </Form.Item>
                        <Form.Item
                            label="客户名称"
                            name="customerName"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入客户名称',
                                },
                            ]}
                        >
                            <Input className="admin-form-input" placeholder="请输入客户名称" />
                        </Form.Item>
                    </div>

                    <Form.Item
                        label="发送短信"
                        name="sendSms"
                        help="创建订单后自动发送短信给客户"
                    >
                        <Switch />
                    </Form.Item>

                    <Form.Item
                        label="省市区"
                        name="geo"
                        rules={[
                            {
                                required: true,
                                message: '请选择省份！',
                            },
                        ]}
                    >
                        <Geo />
                    </Form.Item>

                    <Form.Item
                        label="详细地址"
                        name="address"
                        rules={[
                            {
                                required: true,
                                message: '请输入地址！',
                            },
                        ]}
                    >
                        <Input className="admin-form-input" placeholder="请输入详细地址" />
                    </Form.Item>
                    
                    {/* 价格信息 - 响应式布局 */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
                        <Form.Item
                            label="总价"
                            name="shouldAmount"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入正确的金额',
                                },
                            ]}
                        >
                            <InputNumber 
                                className="admin-form-input w-full" 
                                type='number' 
                                min={0} 
                                placeholder="请输入总价"
                            />
                        </Form.Item>
                        <Form.Item
                            label="数量"
                            name="quantity"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入数量',
                                },
                            ]}
                        >
                            <InputNumber 
                                className="admin-form-input w-full" 
                                type='number' 
                                min={1} 
                                step={1}
                                placeholder="请输入数量"
                            />
                        </Form.Item>
                        <Form.Item label="单价">
                            <span className="text-red-500 font-semibold">
                                {((amount || 0) / quantity).toFixed(2)}{unit ? '/'+unit: ''}
                            </span>
                        </Form.Item>
                    </div>
                    
                    {/* 预约时间 - 响应式布局 */}
                    {goodsType === 'NORMAL' && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                            <Form.Item
                                label="预约日期"
                                name="appointmentDate"
                            >
                                <DatePicker
                                    locale={zhCN}
                                    placeholder='预约日期'
                                    className="w-full"
                                    changeOnScroll={true}
                                    needConfirm={false}
                                    showNow={true}
                                />
                            </Form.Item>
                            <Form.Item
                                label="预约时间"
                                name="appointmentTime"
                            >
                                <TimePicker
                                    className="w-full"
                                    placeholder='预约时间'
                                    minuteStep={10}
                                    showNow={false}
                                    showTime={{
                                        defaultValue: dayjs('08:00', 'HH:mm'),
                                        format: 'HH:mm',
                                    }}
                                />
                            </Form.Item>
                        </div>
                    )}
                    {/* <Form.Item
                        label="分销员"
                        name="guideId"
                        rules={[
                            {
                                required: true,
                                message: '请选择分销员！',
                            },
                        ]}
                    >
                        <Radio.Group options={[{label: '我自己', value: -1 }, {label: '总公司', value: 9}]} />
                    </Form.Item> */}

                    {/* 订单来源 */}
                    <Form.Item
                        label="订单来源"
                        name="from"
                        rules={[
                            {
                                required: true,
                                message: '请选择来源！',
                            },
                        ]}
                    >
                        <Radio.Group 
                            options={fromOptions} 
                        />
                    </Form.Item>

                    <Form.Item
                        label="分销/代理"
                        name="shareType"
                        help="个人：登录人获得佣金；店铺：选择后的店铺获得佣金"
                        rules={[{ required: true, message: '请选择分销/代理' }]}
                    >
                        <Radio.Group 
                            options={[{ value: 1, label: '个人' }, { value: 2, label: '总部' }]} 
                        />
                    </Form.Item>

                    {/* {
                        shareType === 2 && <Form.Item
                            label="代理店铺"
                            name='shareShopId'
                            rules={[{ required: true, message: '请选择代理店铺' }]}
                        >
                            <Select placeholder="请选择代理店铺" 
                                options={
                                    (proxyShops || [])
                                        .filter(item => item.shopId !== currentShopId)
                                } 
                            />
                        </Form.Item>
                    } */}
                    
                    <Form.Item
                        label="备注"
                        name="sellerRemark"
                    >
                        <Input.TextArea className="admin-form-input" rows={4} placeholder="请输入备注信息" />
                    </Form.Item>
                    
                    <div className="admin-form-actions">
                        <Button onClick={() => goback('/order-list-als')}>取消</Button>
                        <Button type='primary' onClick={onFormSubmit}>提交</Button>
                    </div>
                </Form>
            </div>
        </>
    );
};

export default NewOrder;